SupportLocationListElementTemplate = require '../../../../location_list_element_view.html.mustache'
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormUSLocationListElementView extends Backbone.View
  tagName: 'td'

  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.support'
    @template = SupportLocationListElementTemplate
    _.bindAll.apply(_, [this].concat(_.functions(this)))

  events:
    'change .add':'onChangeSelection'

  render: ->
    @$el.html toHtml(@template, @toHash(), @I18nScope)

  toHash: ->
    locObj = @options.location
    locObj.isMarked = locObj.isSelected
    if locObj.isSelected
      locObj.checked = "checked"
    else
      locObj.checked = ""
    locObj.firstLine = "#{locObj.streetAddress1},#{locObj.city}"
    locObj.secondLine = "#{locObj.state},#{locObj.postalCode}"
    locObj

  onChangeSelection: ->
    @options.location.isMarked = !@options.location.isMarked

module.exports = EmailFormUSLocationListElementView
